import {BehaviorSubject, combineLatestWith} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {importantAnnouncementHeight$, ipPromptHeight$} from '@/modules/header/stream';

export const scrollY$ = new BehaviorSubject(0);
export const element$ = new BehaviorSubject<HTMLElement>(null);
export const coordinate$ = new BehaviorSubject({left: 0, top: 0});

const HEIGHT_HEIGHT = 64;

element$
  .pipe(
    filter((element) => !!element),
    map((element) => {
      const rect = element.getBoundingClientRect();
      return rect.left;
    }),
    combineLatestWith(importantAnnouncementHeight$, ipPromptHeight$, scrollY$),
    map(([left, top, ipPromptHeight, scrollY]) => {
      const diff = top + ipPromptHeight - scrollY;
      return {left, top: Math.max(diff, 0) + HEIGHT_HEIGHT};
    })
  )
  .subscribe((coordinate) => coordinate$.next(coordinate));
